import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh-CN'
import en from './en'
import fr from './fr'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import frLocale from 'element-ui/lib/locale/lang/fr'

Vue.use(VueI18n)

const messages = {
    zh: Object.assign(zh, zhLocale),
    en: Object.assign(en, enLocale),
    fr: Object.assign(fr, frLocale),
}

const i18n = new VueI18n({
    locale: 'zh',
    messages
})

export default i18n;